import { z } from 'zod';

export const BillingAccountResponseSchema = z.object({
  ariaAccountId: z.number().nullable(),
  billingCurrencyId: z.number().nullable(),
  billingDayOfMonth: z.number().nullable(),
  billingSystemVersion: z.number().nullable(),
  currency: z.string().nullable(),
  customerId: z.number().nullable(),
  languageTag: z.string().nullable(),
  noPrepayAutoRenewOptin: z.number().nullable(),
});

// TypeScript Interfaces
export type BillingAccountResponse = z.infer<typeof BillingAccountResponseSchema>;
